import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["innerHTML"]

import { getFont } from "@/helpers/fonts";
import { useDeviceStatus } from "@/stores/deviceStatus";
import { StyleValue, computed, onBeforeMount, ref, toRefs } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WksOpenInputPopUpBtn',
  props: {
  buttons: {
    type: Array<{
      route: string;
      src: string;
      svg: string;
      name: string;
      routeName: string;
    }>,
    required: true,
  },
},
  emits: ["click"],
  setup(__props) {




const nore12 = ref<StyleValue>();
onBeforeMount(async () => {
  nore12.value = (await getFont("nore12")) as StyleValue;
});

const { isWeb } = toRefs(useDeviceStatus());
const getBtnCss = computed(() => {
  if (isWeb.value) {
    return {
      border: "solid var(--worksheet-difficulty-border) 1px",
    };
  }
  return {};
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "options-box",
    style: _normalizeStyle(getBtnCss.value)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (button, key) => {
      return (_openBlock(), _createElementBlock("div", {
        onClick: ($event: any) => (_ctx.$emit('click', button.routeName)),
        style: _normalizeStyle(nore12.value),
        key: key,
        class: "option-button-wrapper"
      }, [
        _createElementVNode("div", {
          class: "option-button",
          innerHTML: button.svg
        }, null, 8, _hoisted_2),
        _createElementVNode("span", null, _toDisplayString(button.name), 1)
      ], 12, _hoisted_1))
    }), 128))
  ], 4))
}
}

})